import React from 'react';
import styles from 'styles/components/lib/tables/dnd/dndDivider.css';

const DnDDivider = (props) => {
  return (
    <div className={styles.container}>
      <hr/>
      <h5>{props.header}</h5>
      <hr/>
    </div>
  )
}

export default DnDDivider;



// WEBPACK FOOTER //
// ./src/scripts/components/lib/tables/dnd/DnDDivider.js